module.exports = __webpack_public_path__ + "static/postItFooter-f43a8f7b183b771c3c1b92c254f98a48.svg";